import script from "./ViewOrganization.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewOrganization.vue?vue&type=script&setup=true&lang=js"

import "./ViewOrganization.vue?vue&type=style&index=0&id=df52adc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df52adc6"]])

export default __exports__